import { render, staticRenderFns } from "./StaticMenu.vue?vue&type=template&id=1a58a6fd&scoped=true"
import script from "./StaticMenu.vue?vue&type=script&lang=js"
export * from "./StaticMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58a6fd",
  null
  
)

export default component.exports